import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import PostCard from "../components/PostCard";
import { posts } from "../data/posts";

export default function Blog() {
  return (
    <section className="py-5">
      <Helmet>
        <title>Blog de Psicologia | Psicóloga Elaine Rampazzo</title>
        <meta
          name="description"
          content="Artigos da psicóloga Elaine Rampazzo sobre saúde emocional, ansiedade, depressão, relacionamentos, autoconhecimento e carreira."
        />
        <link rel="canonical" href="https://www.elaineterapia.com.br/blog" />
        <meta property="og:title" content="Blog de Psicologia | Psicóloga Elaine Rampazzo" />
        <meta
          property="og:description"
          content="Artigos sobre saúde emocional, ansiedade, depressão, relacionamentos, autoconhecimento e carreira."
        />
        <meta property="og:image" content="https://www.elaineterapia.com.br/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.elaineterapia.com.br/blog" />
        <meta name="twitter:title" content="Blog de Psicologia | Psicóloga Elaine Rampazzo" />
        <meta
          name="twitter:description"
          content="Artigos sobre saúde emocional, ansiedade, depressão, relacionamentos, autoconhecimento e carreira."
        />
        <meta name="twitter:image" content="https://www.elaineterapia.com.br/og-image.jpg" />
      </Helmet>

      <div className="container">

        {/* BOTÃO VOLTAR */}
        <div className="mb-4">
          <Link to="/" className="btn btn-outline-secondary">
            <i className="bi bi-arrow-left me-2"></i>
            Voltar para o início
          </Link>
        </div>

        {/* Título */}
        <div className="text-center mb-5">
          <h1 className="text-marrom-suave mb-3">
            Blog Terapia e Carreira
          </h1>

          <p className="text-muted">
            Reflexões sobre ansiedade, relacionamentos, autoconhecimento
            e saúde emocional em cada fase da vida.
          </p>
        </div>

        {/* Lista de posts */}
        <div className="row g-4">

          {posts.map((post, index) => (
            <div className="col-md-4" key={index}>
              <PostCard post={post} />
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}